export default {"src":"/_next/static/media/draw-passionnes.4b3443ef.svg","height":141,"width":294,"blurWidth":0,"blurHeight":0};